var UrlResolver = (function () {
    function UrlResolver() {
    }
    UrlResolver.prototype.resolveUrl = function (action) {
        return this.getController(action) + this.getAction(action);
    };
    UrlResolver.prototype.getController = function (action) {
        var controller = action.controller || 'Home';
        if (action.item && action.item['area']) {
            controller = "".concat(action.item['area'], "/").concat(controller);
        }
        if (controller.length > 1 && controller[0] === '/') {
            controller = controller.substring(1);
        }
        return controller;
    };
    UrlResolver.prototype.getAction = function (action) {
        return "/".concat(action.action, "/");
    };
    return UrlResolver;
}());
export { UrlResolver };
